import { DOCUMENT } from '@angular/common'
import { Directive, ElementRef, HostBinding, HostListener, Inject } from '@angular/core'
@Directive({
    selector: '[inputName]',
})
export class InputNameDirective {

    regexStr = /^[a-zA-Zàá]/;
    regexStr2 = /^[a-zA-Zàá ]/;

    @HostBinding('autocomplete') public autocomplete
    constructor(private el: ElementRef) {
        this.autocomplete = 'off'
    }

    @HostListener('keypress', ['$event']) public disableKeys(e: any) {
        const value: string = this.el.nativeElement.value;
        return new RegExp(value.length > 0 && !value.includes(' ') ? this.regexStr2 : this.regexStr).test(e.key);
    }

}